import { render, staticRenderFns } from "./ManageReservations.vue?vue&type=template&id=c0bff4aa&scoped=true&"
import script from "./ManageReservations.vue?vue&type=script&lang=ts&"
export * from "./ManageReservations.vue?vue&type=script&lang=ts&"
import style0 from "./ManageReservations.vue?vue&type=style&index=0&id=c0bff4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bff4aa",
  null
  
)

export default component.exports